import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyAZ35JnTlF7GDVCEGXsQ-nkcf-5W0xo-XM",
  authDomain: "skipeye-5cd98.firebaseapp.com",
  projectId: "skipeye-5cd98",
  storageBucket: "skipeye-5cd98.firebasestorage.app",
  messagingSenderId: "629634838167",
  appId: "1:629634838167:web:3c487e6f5755eeffa3c3d2",
  measurementId: "G-D60TKMLLCC"
};

const app = initializeApp(firebaseConfig);

// Initialize App Check
// - On localhost/127.0.0.1: Uses debug provider with token from REACT_APP_APPCHECK_DEBUG_TOKEN env var
// - In production: Uses reCAPTCHA v3 provider
// For local dev setup: create .env.local with REACT_APP_APPCHECK_DEBUG_TOKEN=<your-token>
// and register that token in Firebase Console > App Check > Manage debug tokens
let appCheck = null;
if (typeof window !== 'undefined') {
  const isLocalDev = window.location.hostname === 'localhost'
    || window.location.hostname === '127.0.0.1';

  if (isLocalDev && process.env.REACT_APP_APPCHECK_DEBUG_TOKEN) {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.REACT_APP_APPCHECK_DEBUG_TOKEN;
  }

  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Lf1ZBksAAAAANHQ-J0rz7RLdOvAhJ3s2Z6w39P0'),
    isTokenAutoRefreshEnabled: true
  });
}

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
// Connect to europe-west1 region to match deployed functions
const functions = getFunctions(app, 'europe-west1');

// Set session persistence
setPersistence(auth, browserSessionPersistence)
  .catch((error) => {
    console.error("Error setting auth persistence:", error);
  });

export { app, db, auth, storage, functions, appCheck };